import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchPricing as fetchBuyPricing } from "slices/pdp-buy-slice";
import { fetchPricing as fetchReservePricing } from "slices/pdp-reserve-slice";
import { isActiveMembership } from "helpers/membership-helpers";
import { UPDP_BUYBOX_MODES } from "rtr-constants";

export default function useFetchPricing() {
  const dispatch = useDispatch();
  const staticProduct = useSelector(state => state.staticProduct);
  const membershipState = useSelector(state => state.membershipState);
  const workingFilters = useSelector(state => state.workingFilters) || {};
  const membershipStateLoading = useSelector(state => state.membershipStateLoading);
  const buyBoxMode = useSelector(state => state.pdp?.pdpBuyBoxMode);

  useEffect(() => {
    if (staticProduct && buyBoxMode !== UPDP_BUYBOX_MODES.CLEARANCE) {
      dispatch(fetchBuyPricing({ productId: staticProduct.productId }));
    }
  }, [staticProduct]);

  useEffect(() => {
    if (membershipStateLoading === false && staticProduct?.productId && buyBoxMode !== UPDP_BUYBOX_MODES.CLEARANCE) {
      dispatch(
        fetchReservePricing({
          productId: staticProduct.productId,
          rentalDuration: workingFilters.duration || 4,
          activeMember: isActiveMembership(membershipState),
        })
      );
    }
  }, [membershipStateLoading, membershipState, workingFilters.duration, staticProduct.productId]);
}
